import { Fab, FabProps } from '@mui/material';
import React from 'react';
import { buildToolContextLink } from '../../utils/common';
import { getClgLinkTemplate, useBuildEmobilityLink } from '../../utils/customHooks';

export type ClgCtaLink = {
	clgEndpoint: string;
	tool: string;
};

export type CtaLink = string | ClgCtaLink;

export type CtaLinkParams = { [key: string]: string | number | boolean };

export type CtaProps = Omit<FabProps<'a'>, 'onClick' | 'children' | 'variant' | 'type' | 'href'> & {
	link: CtaLink;
	label: string;
	bid: string;
	culture: string;
	dealer?: string;
	params?: CtaLinkParams;
	type?: string;
	onClick?: (href: string, label: string, type: string) => void;
	className?: string;
};

export const Cta = (props: CtaProps) => {
	const { link, type, onClick, bid, culture, dealer, params, label, ...other } = props;
	const template = typeof (link) === 'string' ? link : getClgLinkTemplate(link.clgEndpoint, link.tool, dealer, params);
	const buildEmobilityLink = useBuildEmobilityLink();
	const filledToolContext = buildToolContextLink(template, bid, culture, dealer, params);
	const filledEmobilityContext = buildEmobilityLink(filledToolContext);

	return (
		<Fab
			data-test='cta'
			variant='extended'
			href={filledEmobilityContext}
			rel='noopener'
			onClick={() => onClick(filledEmobilityContext, label, type)}
			{...other}>
			{label}
		</Fab>
	);
};

Cta.defaultProps = {
	color: 'primary',
	target: '_blank'
};
